<template>
    <div>
        <b-row>
            <b-col cols="12">
                <label>Cliente</label>
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectedClient"
                />
            </b-col>
            <b-col cols="12" v-if="selectedClient">
                <app-notebook-page :theClient="selectedClient" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import clientsRepository from '../../../../repositories/clients.repository.js';
import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import NotebookPage from '../NoteBookPage/NoteBookPage';
export default {
    components: {
        appAutocomplete: Autocomplete,
        appNotebookPage: NotebookPage
    },
    data(){
        return {
            clients: [],
            selectedClient: '',
            theClientId: ''
        }
    },
    methods: {
        loadClients(){
            const cr = {...clientsRepository};
            const filters = { module_slug: 'escoltas' }
            cr.getClientsOptionalModule(filters)
            .then(data => this.clients = data)
            .catch(error => toastr.error('Error al cargar los clientes'));
        },
    },
    created(){
        this.loadClients();
    }
}
</script>


